export default {
  title: {
    id: 'checkout_step_addresses_billing_title',
    defaultMessage: 'Billing address',
  },
  edit: {
    id: 'checkout_step_addresses_billing_edit',
    defaultMessage: 'Edit address',
  },
  submitButton: {
    id: 'checkout_step_addresses_submit',
    defaultMessage: 'Confirm address',
  },
}
